// material-ui
import { useTheme } from '@mui/material/styles';
import WebsiteLogo from "../../assets/image/favicon.png"
import { Box } from '@mui/material';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {

  return (
    <Box
      component={"img"}
      src={WebsiteLogo}
    />
  );
}
